<script>
import appConfig from '@/app.config'
import PageHeader from '@/components/page-header'
import Layout from '@/router/layouts/main'
import { mapGetters } from 'vuex'
import { Helper } from '@/mixin/helper'

import {
  ASSET_MUTATION_UPDATE,
  GET_MUTATION_ASSET,
} from '@/services/api/setting/personalization/uiAsset'
/**
 * Starter component
 */
export default {
  page: {
    title: 'Manajemen Whitelabel',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
  },
  mixins: [Helper],
  apollo: {
    uiAsset: {
      query: GET_MUTATION_ASSET,
      manual: true,
      fetchPolicy: 'no-cache',
      result({ data, loading }) {
        if (!loading) {
          this.primaryColor = data.uiAssets.uiAssets.find(
            (o) => o.assetType === 'primaryColor' && o.module === 'general'
          ).value
          this.secondaryColor = data.uiAssets.uiAssets.find(
            (o) => o.assetType === 'secondaryColor' && o.module === 'general'
          ).value
          this.fontColor = data.uiAssets.uiAssets.find(
            (o) => o.assetType === 'fontColor' && o.module === 'general'
          ).value
        }
      },
    },
  },
  data() {
    return {
      primaryColor: null,
      secondaryColor: null,
      fontColor: null,
      showResetColor: false,
      showResetColorFont: false,
      goBack: false,
    }
  },

  computed: {
    ...mapGetters({
      hasAccess: 'identity/hasAccess',
      hasAccessAll: 'identity/hasAccessAll',
    }),
    title() {
      return this.$t('setting.list.managementAsset.color.title')
    },
    items() {
      return [
        {
          text: this.$t('setting.homePage.pengaturan'),
          to: { name: 'Setting' },
        },
        {
          text: this.$t('setting.homePage.whitelabel'),
          to: { name: 'Management Whitelabel' },
        },
        {
          text: this.$t('setting.list.managementAsset.color.title'),
          active: true,
        },
      ]
    },
  },

  methods: {
    onChangeColor(e) {
      const indexField = e.target.id
      if (indexField == 'fontColor') {
        this.showResetColorFont = true
      } else {
        this.showResetColor = true
      }
      this.goBack = true
    },
    toSave() {
      const input = [
        {
          assetType: 'primaryColor',
          module: 'general',
          data: {
            value: this.primaryColor,
            isActive: true,
            isPhoto: false,
            photoExt: null,
          },
        },
        {
          assetType: 'secondaryColor',
          module: 'general',
          data: {
            value: this.secondaryColor,
            isActive: true,
            isPhoto: false,
            photoExt: null,
          },
        },
        {
          assetType: 'fontColor',
          module: 'general',
          data: {
            value: this.fontColor,
            isActive: true,
            isPhoto: false,
            photoExt: null,
          },
        },
      ]
      this.$apollo
        .mutate({
          mutation: ASSET_MUTATION_UPDATE,
          variables: {
            input: input,
          },
        })
        .then((response) => {
          if (response.data.updateUIAssets.message != 'Successful') {
            return this.$mcToast.error(this.$t('global.alert.text.failSave'))
          }
          this.goBack = false
          this.showResetColor = false
          this.showResetColorFont = false
          return this.$mcToast.success(this.$t('global.alert.text.saved'))
        })
    },
    resetColor(indexReset) {
      if (indexReset == 'brandColor') {
        this.primaryColor = '#0D4491'
        this.secondaryColor = '#1C74DA'
      }
      if (indexReset == 'fontColor') {
        this.fontColor = '#01133D'
      }
    },
    toBack() {
      if (this.goBack) {
        return this.$bvModal.show('modalConfirmation')
      }
      this.$router.push({ name: 'Management Whitelabel' })
    },
  },
}
</script>

<template>
  <Layout>
    <div class="mc-list-header">
      <PageHeader :title="title" :items="items" class="mc-page-three" />
      <p class="mb-4">{{ $t('setting.list.managementAsset.color.subtitle') }}</p>
      <div class="clearfix mc-btn-group__list mc-btn-group__list--detail">
        <div class="float-end">
          <b-button
            @click="toBack()"
            variant="outline-primary"
            class="ms-3"
            @focus="$event.target.blur()"
          >
            <i class="mc-fa icon-outline_arrow-left"></i>
            {{ $t('global.back') }}
          </b-button>
          <b-button @click="toSave()" variant="btn btn-primary" class="ms-3">
            <i class="mc-fa icon-fill_checkmark"></i>
            {{ $t('global.apply') }}
          </b-button>
        </div>
      </div>
    </div>

    <div class="mc-form">
      <b-row>
        <b-col md="6">
          <h4 class="card-title">{{ $t('setting.list.managementAsset.color.brandColor') }}</h4>
        </b-col>
        <b-col md="6">
          <div class="float-end">
            <b-button
              @click="resetColor('brandColor')"
              variant="outline-primary"
              class="text-right"
              id="resetColorBrand"
              v-show="showResetColor"
            >
              <i class="mc-fa icon-fill_refresh"></i>
              {{ $t('global.resetAsset') }}
            </b-button>
          </div>
        </b-col>
      </b-row>
      <b-card>
        <b-row>
          <b-col sm="12" md="6">
            <b-row>
              <b-col md="6">
                <h6>{{ $t('setting.list.managementAsset.color.primaryColor') }}</h6>
                <div class="mc-input-info d-flex">
                  <b-form-group>
                    <input
                      class="mc-form-input__color"
                      type="color"
                      id="primaryColor"
                      v-model="primaryColor"
                      v-on:change="onChangeColor"
                    />
                  </b-form-group>
                  <b-form-group>
                    <input class="form-control" type="text" v-model="primaryColor" readonly />
                  </b-form-group>
                </div>
              </b-col>
              <b-col md="6">
                <h6>{{ $t('setting.list.managementAsset.color.secondaryColor') }}</h6>
                <div class="mc-input-info d-flex">
                  <b-form-group>
                    <input
                      class="mc-form-input__color"
                      type="color"
                      id="secondaryColor"
                      v-model="secondaryColor"
                      v-on:change="onChangeColor"
                    />
                  </b-form-group>
                  <b-form-group>
                    <input class="form-control" type="text" v-model="secondaryColor" readonly />
                  </b-form-group>
                </div>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-card>
    </div>

    <div class="mc-form">
      <b-row>
        <b-col md="6">
          <h4 class="card-title">{{ $t('setting.list.managementAsset.color.fontColor') }}</h4>
        </b-col>
        <b-col md="6">
          <div class="float-end">
            <b-button
              @click="resetColor('fontColor')"
              variant="outline-primary"
              class="text-right"
              id="resetColorFont"
              v-show="showResetColorFont"
            >
              <i class="mc-fa icon-fill_refresh"></i>
              {{ $t('global.resetAsset') }}
            </b-button>
          </div>
        </b-col>
      </b-row>
      <b-card>
        <b-row>
          <b-col sm="12" md="6">
            <b-row>
              <b-col md="12">
                <h6>{{ $t('setting.list.managementAsset.color.generalText') }}</h6>
                <div class="mc-input-info d-flex">
                  <b-form-group>
                    <input
                      class="mc-form-input__color"
                      type="color"
                      id="fontColor"
                      v-model="fontColor"
                      v-on:change="onChangeColor"
                    />
                  </b-form-group>
                  <b-form-group>
                    <input class="form-control" type="text" v-model="fontColor" readonly />
                  </b-form-group>
                </div>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-card>
    </div>

    <b-modal
      id="modalConfirmation"
      centered
      no-close-on-esc
      no-close-on-backdrop
      :title="$t('setting.list.managementAsset.color.exitPage')"
      :ok-title="$t('setting.list.managementAsset.color.stayPage')"
      :cancel-title="$t('setting.list.managementAsset.color.exitPage')"
      @ok="$bvModal.hide('modalConfirmation')"
      @cancel="$router.push({ name: 'Management Whitelabel' })"
      modal-class="mc-confirm__exit-page"
    >
      <p>{{ $t('setting.list.managementAsset.color.confirmText') }}</p>
      <p>{{ $t('setting.list.managementAsset.color.confirmBody') }}</p>
    </b-modal>
  </Layout>
</template>
